import React, { createContext, ReactNode, useState } from 'react';
import { getOAuth2Store } from '@/store';

interface AuxProps {
    children: ReactNode;
}

export const AuthenticationContext = createContext(null);
const { Provider } = AuthenticationContext;

const AuthenticationProvider = ({ children }: AuxProps) => {
    const initialStore = getOAuth2Store();
    const [accessToken, setAccessToken] = useState(
        initialStore?.accessToken ?? null,
    );

    return (
        <Provider value={[accessToken, setAccessToken]}>{children}</Provider>
    );
};

AuthenticationProvider.context = AuthenticationContext;

export default AuthenticationProvider;
